import React, { useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../DMSHeader/DMSHeader";
import SOPTable from "./SOPTable/SOPTable";
import { useTranslation } from 'react-i18next';

const SoPManagement = (props) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { state } = useLocation();
  const edit_data = state?.data;
  const isEditMode = state?.edit === true;
  

  useEffect(() => {
    GridStack.init();
  }, []);
 
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
        title={
          // view ? t('View Contact Detaiils') :
          isEditMode ? t("Update SOP") : t("SOP List")
        }
          fileName="SOPManagement"
          showmenu={true}
          showdownload={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <SOPTable />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default SoPManagement;
